module.exports = {
  container: {
    center: true,
    padding: "15px",
  },
  extend: {
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1330px",
      "2xl": "1330px",
      "lg-down": {
        max: "1329px",
      },
      "md-down": {
        max: "1023px",
      },
      "sm-down": {
        max: "767px",
      },
      "sm-only": {
        max: "669px",
      },
    },
    fontFamily: {
      sans: ["Catamaran", "Montserrat", "arial", "sans-serif"],
      heading: ["DaysOne", "Trebuchet MS", "Helvetica", "sans-serif"],
      daysone: ["DaysOne", "Trebuchet MS", "Helvetica", "sans-serif"],
      catamaran: ["Catamaran", "Montserrat", "arial", "sans-serif"],
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      "body-background": "#ffffff",
      "body-text": "#333333",
      black: {
        DEFAULT: "#000000",
      },
      white: {
        DEFAULT: "#ffffff",
      },
      primary: {
        DEFAULT: "#031A89",
        50: "#e5f2ff",
        100: "#d0e8ff",
        200: "#abd2ff",
        300: "#79b3ff",
        400: "#4482ff",
        500: "#1b50ff",
        600: "#002eff",
        700: "#0031ff",
        800: "#002ade",
        900: "#031a89",
        950: "#031163",
        hover: "#031A89",
      },
      accent: {
        DEFAULT: "#f543b0",
        light: "#fef1fa",
        50: "#fef1fa",
        100: "#fde6f6",
        200: "#fdcdee",
        300: "#fda4df",
        400: "#fb6bc7",
        500: "#f543b0",
        600: "#e51d8e",
        700: "#c70f71",
        800: "#a4105e",
        900: "#891250",
        950: "#54032d",
        hover: "#fde6f6",
      },
      secondary: {
        DEFAULT: "#FF6300",
        light: "#fff8ec",
        50: "#fff8ec",
        100: "#ffefd3",
        200: "#ffdba5",
        300: "#ffc16d",
        400: "#ff9a32",
        500: "#ff7c0a",
        600: "#ff6300",
        700: "#cc4602",
        800: "#a1370b",
        900: "#822f0c",
        950: "#461504",
        hover: "#ffefd3",
      },
      blue: {
        DEFAULT: "#031A89",
        50: "#C0CBFE",
        100: "#ACBAFD",
        200: "#8499FC",
        300: "#5D78FB",
        400: "#3557FB",
        500: "#0D35FA",
        600: "#0529D9",
        700: "#0422B1",
        800: "#031A89",
        900: "#021052",
        950: "#010A37",
      },
      purple: {
        DEFAULT: "#812C97",
        50: "#FCF8FD",
        100: "#F5E8F8",
        200: "#E7C9EF",
        300: "#D9A9E6",
        400: "#CC89DD",
        500: "#BE6AD4",
        600: "#B04ACA",
        700: "#9C35B7",
        800: "#812C97",
        900: "#5C1F6C",
        950: "#491956",
      },
      light: "#D9EDEE",
    },
    lineHeight: {
      heading: "1.27",
    },
    margin: {
      container: "15px",
    },
    borderRadius: {
      button: "23px",
    },
    boxShadow: {
      card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
      callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
    },
  },
};
